angular
    .module('empower.faqs')
    .controller('faqsController', ['$rootScope', '$scope', 'faqService' , 
        function ($rootScope, $scope, faqService) {
            $scope.faqCategories;

            $scope.init = function () {
                faqService.getFaqList().then(function (response) {
                    $scope.faqCategories = response;
                    if($scope.faqCategories.length > 0)
                        $scope.activeCategory = $scope.faqCategories[0].Id;
                        
                    });
            }

            $scope.showCategory = function(categoryId) {
                $scope.activeCategory = categoryId;
            }

            // $scope.parseHtml = function(string) {
            //     return $sce.trustAsHtml(string);
            // }
    }])
    .filter('to_trusted', ['$sce', function($sce){
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    }]);
